import React, { Fragment, useContext, useState } from 'react';
import { Container, Row, Col, Card, CardBody, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { Link } from 'react-router-dom';
import H3 from '../Headings/H3Element';
import CustomizerContext from '../../_helper/Customizer';
import SvgIcon from '../../Components/Common/Component/SvgIcon';
import DropdownCommon from '../../Components/Common/Dropdown';
import { H5, H6, UL, LI, P, Image } from '../../AbstractElements';

import menu_car from '../../assets/images/drts_home/menu_car.png';
import menu_driver from '../../assets/images/drts_home/menu_driver.png';
import menu_bus from '../../assets/images/drts_home/menu_bus.png';

import menu_carb from '../../assets/images/drts_home/menu_car2.png';
import menu_driverb from '../../assets/images/drts_home/menu_driver2.png';
import menu_busb from '../../assets/images/drts_home/menu_bus2.png';

const Breadcrumbs = (props) => {
  
  const [isMenuHovering1, setIsMenuHovering1] = useState(false);
  const [isMenuHovering2, setIsMenuHovering2] = useState(false);
  const [isMenuHovering3, setIsMenuHovering3] = useState(false);
  const [isMenuHovering4, setIsMenuHovering4] = useState(false);

  return (
    <Fragment style={{margin:"5px"}}>
     <Container fluid={true} style={{margin:"5px"}}>
	  
		
    <Row style={{margin:"0px"}}>
         <Col  style={{paddingLeft:5, paddingTop:3, paddingBottom:3, marginTop:"25px", marginBottom:"0px", borderRadius: "0.7rem", backgroundColor:"#ffffff"}} >
           {/*<Card style={{paddingTop:'0px', paddingBottom:'0px',backgroundColor:"#000000"}}>*/}
             <Row style={{paddingTop:'0px', paddingBottom:'0px'}}>
            <Col  md="3" 
              onMouseEnter={() => setIsMenuHovering1(true)}
              onMouseLeave={() => setIsMenuHovering1(false)}
            style={{paddingLeft:'10px',paddingTop:'10px', paddingBottom:'5px', margin:"0px"}}> 
                                 
             
             <Row style={{ marginLeft:"10px",paddingTop:'0px', paddingBottom:'0px' }} >           
                <Col md="4" 
              
                style={{backgroundColor: isMenuHovering1 ? '#4c9dc02b' : "#fcf7e5", 
                width:"70px",
                borderBottom: isMenuHovering1 ? '2px solid #6ec6ec' : "2px solid #f97d2b", 
                borderRadius: "0.7rem", paddingRight:'0px',textAlign: 'right'}} >
                  <Link to={`${process.env.PUBLIC_URL}/eservices/DriverLicensing`} alt="Access eServices for Driver Licensing"> 
                    
                  <Image attrImage={{ src: `${isMenuHovering1 ? menu_driverb : menu_driver}`, alt: 'Welcome to DRTS Web Portal', width:50,textAlign: 'right' }} />
                 
                  </Link>
                </Col>
                <Col md="8" 
               
                style={{ backgroundColor: "#ffffff", 
                borderBottom: isMenuHovering1 ? '2px solid #6ec6ec' :"2px solid #f97d2b",
                borderRadius: "0.7rem"}}><Link to={`${process.env.PUBLIC_URL}/eservices/DriverLicensing`}
                style={{color:isMenuHovering1 ? '#6ec6ec' :"#212529"}} alt="Access eServices for Driver Licensing">
                  <span style={{fontSize:'20px'}}>{"Driver "}</span><br />
                <span style={{fontSize:'20px'}}>{"Licensing"}</span></Link>{/*fcf7e5 */}
                </Col>
              </Row>

             </Col >
             <Col  md="3" 
             onMouseEnter={() => setIsMenuHovering2(true)}
             onMouseLeave={() => setIsMenuHovering2(false)}
             style={{paddingLeft:0, paddingTop:'10px', paddingBottom:'5px', margin:"0px", paddingRight:"0px"}}>  

              <Row style={{ marginLeft:"10px",paddingTop:'0px', paddingBottom:'0px' }}>           
                <Col md="4" 
                
                style={{backgroundColor:  isMenuHovering2 ? '#4c9dc02b' :"#dcede3", 
                width:"70px",
                borderBottom: isMenuHovering2 ? '2px solid #6ec6ec' : "2px solid #66bd7b", borderRadius: "0.7rem",paddingTop:'10px',paddingRight:'0px',textAlign: 'right'}}>
                  <Link to={`${process.env.PUBLIC_URL}/eservices/VehicleLicensing`} alt="Access eServices for Vehicle Licensing"> 
                   
                    <Image attrImage={{ src: `${isMenuHovering2 ? menu_carb : menu_car}`, alt: 'Welcome to DRTS Web Portal', width:50 }} />
                 
                  </Link>
                  </Col>
                <Col md="8" 
               
                style={{backgroundColor: "#ffffff",
                borderBottom: isMenuHovering2 ? '2px solid #6ec6ec' : "2px solid #66bd7b",
                borderRadius: "0.7rem"}}><Link to={`${process.env.PUBLIC_URL}/eservices/VehicleLicensing`}
                style={{color:isMenuHovering2 ? '#6ec6ec' :"#212529"}} 
                alt="Access eServices for Vehicle Licensing">
                  <span style={{fontSize:'20px'}}>{"Vehicle "}</span><br />
                <span style={{fontSize:'20px'}}>{" Licensing"}</span></Link>{/**dcede3 */}
                </Col>
              </Row>

              </Col >
              <Col md="3" 
              onMouseEnter={() => setIsMenuHovering3(true)}
              onMouseLeave={() => setIsMenuHovering3(false)}
              style={{paddingLeft:0, paddingTop:'10px',  paddingBottom:'5px', margin:"0px"}}> 


              <Row style={{ marginLeft:"10px",paddingTop:'0px', paddingBottom:'0px' }}>           
                <Col md="4" style={{backgroundColor:  isMenuHovering3 ? '#4c9dc02b' :"#f4d5dc", 
                width:"70px",
                borderBottom: isMenuHovering3 ? '2px solid #6ec6ec' : "2px solid #84001a", borderRadius: "0.7rem", paddingTop:'8px',paddingRight:'0px',textAlign: 'right'}}>
                  <Link to={`${process.env.PUBLIC_URL}/eservices/TransportPermits`} alt="Access eServices for Transport Permits"> 
                    
                  <Image attrImage={{ src: `${isMenuHovering3 ? menu_busb : menu_bus}`, alt: 'Welcome to DRTS Web Portal', width:50 }} />
                 
                  </Link>
                  </Col>
                <Col md="8" style={{backgroundColor: "#ffffff",
                borderBottom: isMenuHovering3 ? '2px solid #6ec6ec' : "2px solid #84001a",borderRadius: "0.7rem"}}>
                  <Link to={`${process.env.PUBLIC_URL}/eservices/TransportPermits`}
                style={{color:isMenuHovering3 ? '#6ec6ec' :"#212529"}}
                alt="Access eServices for Transport Permits">
                  <span style={{fontSize:'20px'}}>{"Transport "}</span><br />
                <span style={{fontSize:'20px'}}>{"Permits"}</span></Link>{/**f4d5dc */}
                </Col>
              </Row>

            
            </Col>
            <Col  md="3" style={{paddingTop:'20px', paddingBottom:'5px', margin:"0px"}}>
           
               <Row >           
                <Col md="12"
                onMouseEnter={() => setIsMenuHovering4(true)}
                onMouseLeave={() => setIsMenuHovering4(false)}
                >
                    <Link to={`${process.env.PUBLIC_URL}/eservices/PaymentsEServices`} className="btn drts-primary" 
                    style={{ color: 'white',backgroundColor: isMenuHovering4 ? '#f97d2b' :"#6ec6ec" }} 
                    alt="Pay for any Transport Service"> 
                     {"Make a Payment"}</Link>
                    </Col>
              </Row>
                 
            </Col>
            </Row>

            
           {/* </Card> */}
          </Col>
          </Row>  
        
      </Container>
    </Fragment>
  );
};

export default Breadcrumbs;


